import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import PKShowdown from './components/PKShowdown';
import Shows from './components/Shows';
import Guide from './components/Guide';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-canvas text-ink font-body">
      <Navbar />
      <main>
        <Hero />
        <Ranking />
        <PKShowdown />
        <Shows />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}